export default __webpack_public_path__ + "static/media/icon-express.8223531b.png";